import React from 'react';
import styled from '@emotion/styled';

const FilterOverlay = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  z-index: 2;
`;

const FilterOverlayComponent = () => (
  <FilterOverlay className="filter-overlay" />
);

export default FilterOverlayComponent;
